/**
 * Call forgetPreviousUser() at the start of EVERY successful sign-in, before storing the new user.
 *
 * WHY THIS EXISTS: sign-in paths wrote the new user's token over the previous user's state and
 * cleared nothing (only the Logout button did). The next account in the same browser inherited:
 *   - the last session it viewed (`activeSessionId` / `currentSessionId`), which the sidebar's
 *     Results link and several screens read — after the 2026-09-16 route auth sweep, ownership 404s
 *     it and the dashboard reports "Failed to load session information" (2026-09-18: two staff
 *     sign-ins landed on Project Dora's session, which neither account owns);
 *   - its company / organization identity;
 *   - a demo viewer's sessionStorage token, which authHeaders ranks ABOVE a login token, so a real
 *     sign-in in the same tab kept calling the API as the demo viewer.
 *
 * Kept on purpose: browser preferences (`foundations-enterprise-mode`) and the persona magic-link
 * token, which is read only on persona routes and is not the signed-in user's.
 */
export const USER_SCOPED_KEYS = [
  // who is signed in
  'isAuthenticated', 'userRole', 'userId', 'userEmail', 'isSuperadmin', 'isDemoViewer', 'mustChangePassword',
  'authToken', 'token', 'foundations-token', 'defenseAuthToken',
  // whose data
  'companyId', 'companyName', 'organizationId', 'organizationName', 'organizationType',
  // which assessment
  'activeSessionId', 'currentSessionId', 'currentPersona', 'assessmentContext',
] as const;

export function forgetPreviousUser(): void {
  for (const storage of [globalThis.localStorage, globalThis.sessionStorage]) {
    if (!storage) continue;
    for (const key of USER_SCOPED_KEYS) {
      try {
        storage.removeItem(key);
      } catch {
        // storage unavailable — nothing stored there to inherit
      }
    }
  }
}
